import { Bot, LayoutDashboard, Smartphone, LineChart, CalendarClock, ShieldCheck, ArrowRight } from "lucide-react";
import { Reveal, SectionHeading } from "./shared";

const MODULES = [
  { icon: Bot, title: "AI Copilot", copy: "Ask anything about your practice — notes, schedules, and insights drafted instantly." },
  { icon: LayoutDashboard, title: "Doctor Dashboard", copy: "One calm command center for patients, notes, and today's priorities." },
  { icon: Smartphone, title: "Patient Mobile App", copy: "Progress photos, smart reminders and Smile Coach in every patient's pocket." },
  { icon: LineChart, title: "Practice Analytics", copy: "Real-time visibility into efficiency, chair utilization and growth." },
  { icon: CalendarClock, title: "Smart Scheduling", copy: "AI-optimized calendars that fill gaps and quietly reduce no-shows." },
  { icon: ShieldCheck, title: "Admin Portal", copy: "Roles, compliance and billing controls built for enterprise practices." },
];

export default function PlatformOverview() {
  return (
    <section id="platform" data-testid="platform-section" className="relative py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6">
        <SectionHeading
          testId="platform-heading"
          eyebrow="Platform overview"
          title="Every tool your practice needs, aligned"
          sub="Six tightly integrated modules that share one intelligence layer — so nothing falls through the cracks."
        />

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-16">
          {MODULES.map((mod, i) => (
            <Reveal key={mod.title} delay={(i % 3) * 0.1}>
              <div
                data-testid={`platform-card-${mod.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                className="group relative h-full rounded-3xl border border-slate-200/80 bg-gradient-to-b from-white to-[#F8FAFC] p-8 overflow-hidden transition-[box-shadow,transform,border-color] duration-500 hover:-translate-y-2 hover:shadow-[0_30px_60px_-15px_rgba(99,102,241,0.2)] hover:border-[#6366F1]/30"
              >
                <div className="absolute -top-16 -right-16 w-40 h-40 rounded-full bg-[#6366F1]/8 blur-2xl opacity-0 transition-opacity duration-500 group-hover:opacity-100" />
                <div className="relative">
                  <div className="w-13 h-13 inline-flex rounded-2xl border border-slate-200 bg-white p-3.5 shadow-[0_10px_24px_rgba(15,23,42,0.06)] transition-transform duration-500 group-hover:scale-110">
                    <mod.icon className="w-6 h-6 text-[#2563EB]" strokeWidth={1.7} />
                  </div>
                  <h3 className="font-display font-medium text-xl tracking-tight text-[#0F172A] mt-6">
                    {mod.title}
                  </h3>
                  <p className="text-sm text-slate-500 leading-relaxed mt-2.5">{mod.copy}</p>
                  <button
                    type="button"
                    data-testid={`platform-learn-more-${mod.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                    className="inline-flex items-center gap-1.5 text-sm font-semibold text-[#2563EB] mt-5 transition-colors duration-200 hover:text-[#1D4ED8]"
                  >
                    Learn More
                    <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" strokeWidth={2} />
                  </button>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
